import React from "react";

import './rc_timepicker.scss';

import moment from 'moment';
import TimePicker from 'rc-time-picker';


/* this component uses datejs library to format time */
const ReactComponentTimePicker = () => {



  return (
    <div className={`dupa`}>
      <h1 className={`title`} >Godzina odbioru </h1>
    <TimePicker
      defaultValue={moment()}
      showSecond={false}
      minuteStep={15}
      inputReadOnly
      style={{
        border: 'none'
      }}
      allowEmpty={false}
      placeholder={"Podaj czas"}
      defaultValue={null}
      /* onChange={function} */
    />
    </div>
  );
};

export default ReactComponentTimePicker;
